const DASHBOARD_VERSION = "v 1.0.1";
const DASHBOARD_YEAR = "2020";
const DASHBOARD_FOOTER_TEXT = `PACKAGEX INVENTORY ©${DASHBOARD_YEAR}`;
const DASHBOARD_FOOTER_TEXT_BOTTOM = `Powered by PackageX, Inc. © ${DASHBOARD_YEAR}. All rights reserved.`;
const variable = process.env.REACT_APP_ENV;
const env = variable === 'development' ? 'dev' : variable === 'production' ? 'prod' : variable;
const URL_ORIGIN = env === 'prod' ? 'https://api.packagex.app/inventory/v1'
    : env === 'staging' ? 'https://api.packagex.app/inventory/staging'
        : env === 'dev' ? 'https://api.inventoryx.xyz/app_dev' :
            env ? `https://api.inventoryx.xyz/${env}` : "https://api.inventoryx.xyz/app_dev";


const GA_EMAIL = "packagexlabs@packagex.ai";
const GA_PASS = "nL*l36dLY9R?#";
const S3UID = 'd44c83d6-7fc0-4143-a489-252a81a96e97';
const GLOBAL_SEARCH_STATUS_LIST = [
    { label: "No Activity", value: "NO-ACTIVITY" },
    { label: "Pending from Hub", value: "PENDING-FROM-HUB" },
    { label: "At ISP", value: "AT-ISP" },
    { label: "Enroute", value: "ENROUTE" },
    { label: "At Building", value: "AT-BLDG" },
    { label: "Fulfilled", value: "FULFILLED" },
    { label: "ISP Overflow", value: "ISP-OVERFLOW" },
    { label: "Enroute Overflow", value: "ENR-OVERFLOW" },
    { label: "Building Overflow", value: "BLDG-OVERFLOW" },
];
const GLOBAL_SEARCH_CATEGORY_LIST = [
    { label: "Appliances", value: "APPLIANCES" },
    { label: "Plumbing Fixtures", value: "PLUMBING_FIXTURES" },
    { label: "Bathroom Fixtures", value: "BATHROOM_FIXTURES" },
    { label: "Lighting", value: "LIGHTING" },
    { label: "Finishes", value: "FINISHES" },
    { label: "Accessories", value: "ACCESSORIES" },
    { label: "Furniture", value: "FURNITURE" },
    { label: "Office Furniture", value: "OFFICE_FURNITURE" },
    { label: "Conf Furniture", value: "CONF_FURNITURE" },
    { label: "Vendor Art", value: "VENDOR_ART" },
    { label: "Office Furniture & Pre-Fabs", value: "OFFICE_FURNITURE_PRE_FABS" },
    { label: "Studio Art", value: "STUDIO_ART" },
    { label: "Art", value: "ART" },
    { label: "WWLO Furniture", value: "WWLO_FURNITURE" },
    { label: "Operational Assets", value: "OPERATIONAL_ASSETS" },
    { label: "IT", value: "IT" },
    { label: "F&A Additions", value: "FA_ADDITIONS" },
    { label: "Plants", value: "PLANTS" },
    { label: "F&A Enterprise", value: "FA_ENTERPRISE" },
    { label: "Interior Signage", value: "INTERIOR_SIGNAGE" },
    { label: "Flooring", value: "FLOORING" },
    { label: "Other", value: "OTHERS" }
];
const ACTIVITY_LOG = "Activity Logs";

export default {
    GA_EMAIL,
    GA_PASS,
    URL_ORIGIN,
    DASHBOARD_VERSION,
    DASHBOARD_YEAR,
    DASHBOARD_FOOTER_TEXT,
    DASHBOARD_FOOTER_TEXT_BOTTOM,
    S3UID,
    GLOBAL_SEARCH_STATUS_LIST,
    GLOBAL_SEARCH_CATEGORY_LIST,
    ACTIVITY_LOG,
}
